import $ from "jquery";

function initAjaxSolr(){
    var container = $('.tx_solr .results-list-default');
    if (container.length < 1) {
        return null;
    }
    // $('.results-entry').addClass('animate');
    var options = {
        listElement: '.results-list',
        itemSelector: '.results-entry',
        paginator: '.solr-pagination',
        loadCounter: 0,
        offsetViewport: 600,
        pageType: 7383,
        onFinish: function(result) {
            $.fn.matchHeight._apply('[data-match-height="result-title"]');
            $.fn.matchHeight._apply('[data-match-height="result-box"]');
            $.fn.matchHeight._apply('[data-match-height="result-content"]');
            $.fn.matchHeight._apply('[data-match-height="item"]');
            $(result).imagesLoaded(function () {
                $.fn.matchHeight._update();
                $('.focuspoint').focusPoint();
            });
            let prev = null;
          container.find('li.results-entry[data-event-month]').each(function() {
            if (prev != null && prev === this.dataset['eventMonth']) {
              this.style.display = 'none';
            }
            prev = this.dataset['eventMonth'];
          });
        }
    };
    // ref: https://imagesloaded.desandro.com/
    container.imagesLoaded(function () {
        $.fn.matchHeight._update();
    });
    return $.infiniteScroll(container,options);
}
export {initAjaxSolr};

function initAjaxSolrGroups(){
    var container = $('.tx_solr .results-list-group');
    if (container.length < 1) {
        return null;
    }
    // $('.results-entry').addClass('animate');
    var options = {
        listElement: '.results-list',
        itemSelector: '.result-group',
        paginator: '.solr-pagination',
        loadCounter: 0,
        offsetViewport: 600,
        pageType: 7383,
        onFinish: function(result) {
            $.fn.matchHeight._apply('[data-match-height="result-title"]');
            $.fn.matchHeight._apply('[data-match-height="result-box"]');
            $.fn.matchHeight._apply('[data-match-height="result-content"]');
            $.fn.matchHeight._apply('[data-match-height="item"]');
            $(result).imagesLoaded(function () {
                $.fn.matchHeight._update();
            });
        }
    };
    // ref: https://imagesloaded.desandro.com/
    container.imagesLoaded(function () {
        $.fn.matchHeight._update();
    });
    return $.infiniteScroll(container,options);
}

export {initAjaxSolrGroups}
